import Vue from 'vue'
import axios from 'axios'
import store from '@/store'
import storage   from "./storage";
import {
  VueAxios
} from './axios'
import notification from 'ant-design-vue/es/notification'
// 创建 axios 实例
const service = axios.create({
  //baseURL: 'http://192.168.10.63:8888', 
  //timeout: 6000, // 请求超时时间
  withCredentials: true,
});

const err = (error) => {
  if (error.response) {
    const data = error.response.data
    const token = Vue.ls.get('token')
    if (error.response.status === 403) {
      notification.error({
        message: 'Forbidden',
        description: data.message
      })
    }
    if (error.response.status === 401 && !(data.result && data.result.isLogin)) {
      notification.error({
        message: 'Unauthorized',
        description: 'Authorization verification failed'
      })
      if (token) {
        store.dispatch('Logout').then(() => {
          setTimeout(() => {
            window.location.reload()
          }, 1500)
        })
      }
    }
  }
  return Promise.reject(error)
}

// request interceptor
service.interceptors.request.use(config => {
  const token =storage.get('token');
  const headers =storage.get('Content-Type');
  if(headers){
    config.headers={'Content-Type':headers};
    storage.remove('Content-Type');
  }
  if (token) {
    config.headers['token'] = token; // 让每个请求携带自定义 token 请根据实际情况自行修改
    config.headers['Access-Control-Allow-withCredentials'] = true;
  }
  return config;
}, err);

// response interceptor
service.interceptors.response.use(
  res => {
    let data = res.data;
    let method=res.request.custom.method;
    if (res.status == 204) {
      return res;
    }
    else if(res.status == 201) {
      return res;
    }
    else if(res.status == 200&&(method=='GET'||method=='get')) {
      return data;
    }
    else{
      return res;
    }
  },
  error => {
    // console.log(error)
    if(error=='Error: Network Error'){
      sessionStorage.clear();
      setTimeout(() => {
        window.location.reload()
      }, 100)
    }
    // console.log(error.response)
    notification['error']({
      message: '错误',
      duration: 2,
      // description: error.response.data.message?error.response.data.message:error.response.data.msg
      description: error.response.data?error.response.data.exception||error.response.data.message||error.response.data.msg:error.response.data.msg
    })
    // 对响应错误做点什么
    return Promise.reject(error)
  }
)

const installer = {
  vm: {},
  install (Vue) {
    Vue.use(VueAxios, service)
  }
}

export {
  installer as VueAxios,
  service as axios
}



// WEBPACK FOOTER //
// ./src/utils/request.js